
import Vue from 'vue'

export default Vue.extend({
  name: 'HelpSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
